
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FilasComponent } from './filas/filas.component';
import { EditFilaComponent } from './components/edit-fila/edit-fila.component';


const routes: Routes = [
  {
    path: '',
    component: FilasComponent,
  },
  {
    path: 'editar/:id',
    title: 'Editar Fila',
    component: EditFilaComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FilasRoutingModule { }